<template>
  <div class="cookie-comply__modal">
    <div class="cookie-comply__modal-middle">
      <div class="cookie-comply__modal-inner">
        
        <header class="cookie-comply__modal-header">
            <div class="flex-container">
                <font-awesome-icon icon="fa-angle-left" @click="onCloseModal"/>        
                <h3>Vos préférences</h3>
            </div>
        </header>

        <main class="cookie-comply__modal-content">
          <div v-for="(preference, index) in preferences" :key="index">
            <div name="modal-body" :preference="preference" :index="index" class="cookie-comply__modal-slot">
              <h2>{{ preference.title }}</h2>
              <p>{{ preference.description }}</p>
              <div
                v-for="item in preference.items"
                :key="item.value"
                class="cookie-comply__modal-switches"
              >
                <h3>{{ item.label }}</h3>
                <cookie-comply-switch
                  :value="item.value"
                  :is-required="item.isRequired"
                  :is-default-enable="item.isEnable"
                  @update:checkbox="handleCheckboxUpdate"
                />
              </div>
            </div>
          </div>
        </main>

        <div class="cookie-comply__modal-footer">
          <slot name="modal-footer">
            <cookie-comply-button @handleClick="onSaveConfiguration">
              Enregistrer
            </cookie-comply-button>
          </slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CookieComplyButton from './CookieComplyButton.vue';
import CookieComplySwitch from './CookieComplySwitch.vue';

export default {
  name: 'CookieComplyModal',
  components: {
    CookieComplyButton,
    CookieComplySwitch,
  },
  props: {
    preferences: { type: Array, default: () => [{
            title: 'Analytics',
            description: 'Services que nous pouvons offrir',
            items: [
                { label: 'GoogleAnalytics', value: 'ga' },
            ],
        }] },
  },
  emits: ['cookie-comply-save', 'cookie-comply-close'],
  data() {
    return {
      checkedValues: [],
    };
  },
  methods: {
    handleCheckboxUpdate({ value, isEnable }) {
      isEnable
        ? this.checkedValues.push(value)
        : this.checkedValues.splice(this.checkedValues.indexOf(value), 1);
    },
    onSaveConfiguration() {
      this.$emit('cookie-comply-save', this.checkedValues);
    },
    onCloseModal() {
      this.$emit('cookie-comply-close');
    },
  },
};
</script>

<style>
.cookie-comply__modal {
  display: table;
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  background-color: var(--background-overlay);
}

.cookie-comply__modal-middle {
  display: table-cell;
  vertical-align: middle;
}

.cookie-comply__modal-inner {
  position: relative;
  margin-left: auto;
  margin-right: auto;
  width: 400px;
  padding: var(--spacing-lg);
  background-color: var(--color-white);
  border-radius: var(--spacing-sm);
  box-shadow: var(--box-shadow);
}

.cookie-comply__back-arrow {
  position: absolute;
  left: var(--spacing-lg);
  cursor: pointer;
}

.cookie-comply__modal-content {
  max-height: 400px;
  text-align: left;
  margin: 1rem 0;
  padding: 1rem 0;
}

.cookie-comply__modal-switches {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

@media (max-width: 480px) {
  .cookie-comply__modal-middle {
    padding: var(--spacing-md);
  }

  .cookie-comply__modal-inner {
    width: auto;
  }
}

.cookie-comply__modal-header {
  border-bottom: var(--border-color-light);
}

.cookie-comply__modal-slot {
    margin-bottom: 20px;
}

.cookie-comply__modal-footer {
  padding-top: var(--spacing-lg);
  display: flex;
  justify-content: center;
}
</style>